/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetInventoriesList,
  FleetInventoriesParams,
  FleetInventory,
  FleetInventoryCreateInput,
  FleetInventoryUpdateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet Inventory
 */
export const createFleetInventory = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventoryCreateInput: MaybeRefOrGetter<FleetInventoryCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventoryCreateInput = toValue(fleetInventoryCreateInput);

      return axiosClient<FleetInventory>(
      {url: `/fleets/${fleetSlug}/inventories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetInventoryCreateInput, signal
    },
      );
    }




export const getCreateFleetInventoryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventory>>, TError,{fleetSlug: string;data: FleetInventoryCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetInventory>>, TError,{fleetSlug: string;data: FleetInventoryCreateInput}, TContext> => {

const mutationKey = ['createFleetInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetInventory>>, {fleetSlug: string;data: FleetInventoryCreateInput}> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetInventory(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetInventory>>>
    export type CreateFleetInventoryMutationBody = FleetInventoryCreateInput
    export type CreateFleetInventoryMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Fleet Inventory
 */
export const useCreateFleetInventory = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventory>>, TError,{fleetSlug: string;data: FleetInventoryCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetInventory>>,
        TError,
        {fleetSlug: string;data: FleetInventoryCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Inventories List
 */
export const fleetInventories = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetInventoriesList>(
      {url: `/fleets/${fleetSlug}/inventories`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInventoriesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>,) => {
    return [
    'fleets',fleetSlug,'inventories', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInventoriesQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoriesQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventories>>> = ({ signal }) => fleetInventories(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>
}

export type FleetInventoriesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventories>>>
export type FleetInventoriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventories List
 */

export function useFleetInventories<TData = Awaited<ReturnType<typeof fleetInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoriesQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Fleet Inventory
 */
export const destroyFleetInventory = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/inventories/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetInventoryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventory>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventory>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['destroyFleetInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetInventory>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetInventory(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetInventory>>>

    export type DestroyFleetInventoryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Fleet Inventory
 */
export const useDestroyFleetInventory = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventory>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetInventory>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getDestroyFleetInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Inventory Detail
 */
export const fleetInventory = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetInventory>(
      {url: `/fleets/${fleetSlug}/inventories/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'inventories',slug
    ] as const;
    }


export const getFleetInventoryQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventory>>> = ({ signal }) => fleetInventory(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>
}

export type FleetInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventory>>>
export type FleetInventoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Detail
 */

export function useFleetInventory<TData = Awaited<ReturnType<typeof fleetInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Inventory
 */
export const updateFleetInventory = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetInventoryUpdateInput: MaybeRefOrGetter<FleetInventoryUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetInventoryUpdateInput = toValue(fleetInventoryUpdateInput);

      return axiosClient<FleetInventory>(
      {url: `/fleets/${fleetSlug}/inventories/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetInventoryUpdateInput, signal
    },
      );
    }




export const getUpdateFleetInventoryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventory>>, TError,{fleetSlug: string;slug: string;data: FleetInventoryUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventory>>, TError,{fleetSlug: string;slug: string;data: FleetInventoryUpdateInput}, TContext> => {

const mutationKey = ['updateFleetInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetInventory>>, {fleetSlug: string;slug: string;data: FleetInventoryUpdateInput}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetInventory(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetInventory>>>
    export type UpdateFleetInventoryMutationBody = FleetInventoryUpdateInput
    export type UpdateFleetInventoryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Fleet Inventory
 */
export const useUpdateFleetInventory = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventory>>, TError,{fleetSlug: string;slug: string;data: FleetInventoryUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetInventory>>,
        TError,
        {fleetSlug: string;slug: string;data: FleetInventoryUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetInventoryMutationOptions(options), queryClient);
    }
